import React from 'react';
import PropTypes from 'prop-types';
import Cell from 'components/list/Filters/layout/Cell';
import Row from 'components/list/Filters/layout/Row';
import compose from 'recompose/compose';
import utils from 'helpers/utils';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

class Basic extends React.Component {
    componentDidMount() {
        const {
            filterValues,
        } = this.props;

        if (!utils.isEmpty(filterValues)) {
            this.handleInitializeValues(filterValues);
        }
    }

    componentDidUpdate(prevProps) {
        const { filterValues } = this.props;

        const diff = utils.diffObjects(prevProps.filterValues, filterValues);

        if (!utils.isEmpty(diff)) {
            this.handleInitializeValues(filterValues);
        }
    }

    handleInitializeValues = (raw) => {
        const {
            category,
            filters,
            initialize,
        } = this.props;

        let data = {};

        const filterCategory = filters[category];

        utils.each(raw, function (value, key) {
            data[key] = {};

            if (!~Object.keys(filterCategory).indexOf(key)) {
                return;
            }

            utils.each(value, function (itemValue, itemKey) {
                data[key][itemKey] = itemValue;
            });
        });

        initialize(data);
    }

    render() {
        const {
            category,
            filters,
            resource,
        } = this.props;

        const filterCategory = filters[category];

        if (!filterCategory) {
            return null;
        }

        return (
            <Row>
                {
                    utils.map(filterCategory, function (element, key) {
                        const { component } = element;

                        if (!component) {
                            return;
                        }

                        const {
                            label,
                        } = component.props;

                        return (
                            <Cell
                                key={ key }
                            >
                                <Field
                                    allowEmpty
                                    { ...component.props }
                                    component={ component.type }
                                    floatingLabelFixed={ true }
                                    label={ label }
                                    name={ `${ key }[value]` }
                                    resource={ resource }
                                />
                            </Cell>
                        );
                    })
                }
            </Row>
        );
    }
}

Basic.propTypes = {
    category: PropTypes.string,
    filterValues: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    formInstance: PropTypes.object,
    initialize: PropTypes.func.isRequired,
    resource: PropTypes.string.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        filterValues,
    } = props;

    return {
        initialValues: filterValues,
    };
};

const formOnChange = (values, _, props) => {
    const { category, filters } = props;

    let newValues = {};

    // We want to set the matchType to the first value evertime it has not been defined.
    utils.each(values, (value, key) => {
        if (utils.isEmpty(value.value)) {
            return;
        }

        if (!value || !value.matchType) {
            const filterSelector = filters[category][key];

            if (!filterSelector) {
                return;
            }

            let matchType = filterSelector.matchTypes.values[0];

            if (utils.has(filterSelector, 'matchTypes.default')) {
                matchType = filterSelector.matchTypes.default;
            }

            value.matchType = matchType;
        }

        newValues[key] = value;
    });

    return props.updateFilters(newValues);
};

const enhance = compose(
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm({
        enableReinitialize: true,
        keepDirtyOnReinitialize: true,
        onChange: utils.debounce(formOnChange, 800),
    }),
);

export default enhance(Basic);



// WEBPACK FOOTER //
// ./src/components/list/Filters/modes/Basic.js